(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yotsuai-editable-product"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('yotsuai-editable-product'))customElements.define('yotsuai-editable-product',class extends HTMLElement{
connectedCallback(){this.abort=new AbortController();const signal=this.abort.signal;this.form=this.querySelector('form');if(!this.form)return;this.main=this.querySelector('[data-main-buy]');this.bar=this.querySelector('[data-sticky]');this.current=this.dataset.current;this.map={"46702660419663,46702660419663":"46734505803855","46702660419663,46702660452431":"46734505836623","46702660419663,46702660485199":"46734505869391","46702660452431,46702660452431":"46734505902159","46702660452431,46702660485199":"46734505934927","46702660485199,46702660485199":"46734505967695","46702660419663,46702660419663,46702660419663":"46734508752975","46702660419663,46702660419663,46702660452431":"46734508785743","46702660419663,46702660419663,46702660485199":"46734508818511","46702660419663,46702660452431,46702660452431":"46734508851279","46702660419663,46702660452431,46702660485199":"46734508884047","46702660419663,46702660485199,46702660485199":"46734508916815","46702660452431,46702660452431,46702660452431":"46734508949583","46702660452431,46702660452431,46702660485199":"46734508982351","46702660452431,46702660485199,46702660485199":"46734509015119","46702660485199,46702660485199,46702660485199":"46734509047887"};this.money=value=>new Intl.NumberFormat(this.dataset.locale,{style:'currency',currency:this.dataset.currency}).format(Number(value)/100);this.catalog=new Map(Array.from(this.querySelectorAll('[data-variant]'),el=>[el.dataset.variant,el.dataset]));
this.addEventListener('change',event=>{if(event.target.matches('[data-base]')){this.current=event.target.value;this.querySelectorAll('[data-unit]').forEach(select=>{if(!select.dataset.edited)select.value=this.current;});const data=this.catalog.get(this.current);const image=this.querySelector('.ye-main-image');if(image&&data?.image){image.removeAttribute('srcset');image.src=data.image;}}if(event.target.matches('[data-unit]'))event.target.dataset.edited='true';this.refresh();},{signal});
this.form.addEventListener('submit',async event=>{event.preventDefault();event.stopImmediatePropagation();if(this.busy)return;const result=this.selection();if(!result.available||!result.items.length)return;this.busy=true;this.refresh();const error=this.querySelector('.ye-error');if(error)error.hidden=true;try{const response=await fetch(this.dataset.add+'.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:result.items})});const data=await response.json();if(!response.ok)throw new Error(data.description||data.message||this.main?.dataset.error);window.location.assign(this.dataset.cart);}catch(err){if(error){error.textContent=err.message||this.main?.dataset.error;error.hidden=false;}this.busy=false;this.refresh();}},{signal});
this.scroll=()=>{if(this.bar)this.bar.hidden=!this.main||this.main.getBoundingClientRect().bottom>=0||this.getBoundingClientRect().bottom<=0;};window.addEventListener('scroll',this.scroll,{passive:true,signal});window.addEventListener('resize',this.scroll,{signal});this.refresh();this.scroll();}
cardResult(card){const qty=Number(card?.dataset.qty)||1;const ids=card&&qty>1?Array.from(card.querySelectorAll('[data-unit]'),el=>el.value):[this.current];if(card?.dataset.package){const id=card.dataset.known==='true'?this.map[ids.slice().sort().join(',')]:card.querySelector('[data-combination]')?.value;const data=Array.from(card.querySelectorAll('[data-bundle-variant]')).find(el=>el.dataset.bundleVariant===id)?.dataset;return{items:id?[{id,quantity:1}]:[],price:Number(data?.price)||0,compare:Number(data?.compare)||0,available:data?.available==='true'};}const quantities=new Map();if(ids.length===1&&qty>1){quantities.set(ids[0],qty);}else ids.forEach(id=>quantities.set(id,(quantities.get(id)||0)+1));let price=0,compare=0,available=true;for(const[id,quantity]of quantities){const data=this.catalog.get(id);if(!data){available=false;continue;}price+=Number(data.price)*quantity;compare+=Math.max(Number(data.price),Number(data.compare))*quantity;if(data.available!=='true'||(data.tracked==='true'&&data.policy!=='continue'&&quantity>Number(data.stock)))available=false;}return{items:Array.from(quantities,([id,quantity])=>({id,quantity})),price,compare,available};}
selection(){return this.cardResult(this.querySelector('[data-pack-card]:has(input:checked)'));}
refresh(){const current=this.catalog.get(this.current);if(current){this.querySelectorAll('[data-main-price]').forEach(el=>el.textContent=this.money(current.price));this.querySelectorAll('[data-main-compare]').forEach(el=>{el.textContent=this.money(current.compare);el.hidden=Number(current.compare)<=Number(current.price);});this.querySelectorAll('[data-stock-template]').forEach(el=>{el.hidden=current.tracked!=='true';el.textContent=el.dataset.stockTemplate.replaceAll('[stock]',Math.max(0,Number(current.stock)));});}this.querySelectorAll('[data-pack-card]').forEach(card=>{const result=this.cardResult(card);const price=card.querySelector('[data-price]');if(price)price.textContent=this.money(result.price);const compare=card.querySelector('[data-compare]');if(compare){compare.textContent=this.money(result.compare);compare.hidden=result.compare<=result.price;}});const result=this.selection();this.querySelectorAll('[data-main-buy],[data-sticky-buy]').forEach(button=>{button.disabled=this.busy||!result.available;button.setAttribute('aria-busy',String(Boolean(this.busy)));});if(this.main)this.main.textContent=result.available?this.main.dataset.label:this.main.dataset.sold;this.querySelectorAll('[data-sticky-price]').forEach(el=>el.textContent=this.money(result.price));const input=this.form.querySelector('[name="id"]');if(input&&result.items[0])input.value=result.items[0].id;}
disconnectedCallback(){this.abort?.abort();}});

  } catch(e) { console.error(e); }
})();
})();
